<section class="search-area">
  <div class="container">
    <div class="search-area-child">
      <app-search-filter
        (submitEmit)="onSubmitEmitCatch($event)"></app-search-filter>
      <div class="heading-data">
        <!-- This is a temporary solution, in the future it should be replaced with data loaded from the backend -->
        @if (pageData.spot === 'Aalborg' && pageData.service === 'massage') {
          <app-massage-aalborg></app-massage-aalborg>
        } @else if (
          pageData.spot === 'Aarhus' && pageData.service === 'massage'
        ) {
          <app-massage-aarhus></app-massage-aarhus>
        } @else if (
          pageData.spot === 'Koebenhavn' && pageData.service === 'massage'
        ) {
          <app-massage-koebenhavn></app-massage-koebenhavn>
        } @else if (
          pageData.spot === 'Odense' && pageData.service === 'massage'
        ) {
          <app-massage-odense></app-massage-odense>
        } @else if (
          pageData.spot === 'Aalborg' && pageData.service === 'escort'
        ) {
          <app-escort-aalborg></app-escort-aalborg>
        } @else if (
          pageData.spot === 'Aarhus' && pageData.service === 'escort'
        ) {
          <app-escort-aarhus></app-escort-aarhus>
        } @else if (
          pageData.spot === 'Koebenhavn' && pageData.service === 'escort'
        ) {
          <app-escort-koebenhavn></app-escort-koebenhavn>
        } @else if (
          pageData.spot === 'Odense' && pageData.service === 'escort'
        ) {
          <app-escort-odense></app-escort-odense>
        } @else if (
          pageData.spot === 'Valby' && pageData.service === 'escort'
        ) {
          <app-escort-valby></app-escort-valby>
        } @else {
          <h4>{{ pageData.heading }}</h4>
          <p>{{ pageData.firstPara }} <a routerLink="/">tryk her</a>.</p>
          <p>{{ pageData.secondPara }} <a routerLink="/ads">tryk her</a>.</p>
          <p>{{ pageData.thirdPara }} <a routerLink="/login">tryk her</a>.</p>
        }
      </div>
    </div>
  </div>
</section>
